import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=7d53512e"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=ts"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports